export const COLORS = {
  primary: '#00FFB9',
} as const;

// Call Volume Chart Colors — reuse tailwind direction tokens (src/index.css --direction-*) for sync
export const CALL_VOLUME_COLORS = {
  INBOUND: {
    light: 'hsl(var(--direction-inbound))',
    dark: 'hsl(var(--direction-inbound))'
  },
  OUTBOUND: {
    light: 'hsl(var(--direction-outbound))',
    dark: 'hsl(var(--direction-outbound))'
  },
  INBOUND_DIRECT: {
    light: 'hsl(var(--direction-inbound-direct))',
    dark: 'hsl(var(--direction-inbound-direct))'
  },
  INTERNAL: {
    light: 'hsl(var(--direction-internal))',
    dark: 'hsl(var(--direction-internal))'
  }
} as const;

export const LINE_CHART_COLORS = {
  LINE: {
    light: '#23407A',
    dark: '#1681F6'
  },
  DOT_FILL: {
    light: 'white',
    dark: '#0f172a'
  },
  TOOLTIP_TEXT: {
    light: '#1e3a8a', // blue-900
    dark: '#60a5fa'  // blue-400
  }
} as const; 